export default "/static/dashboard/build/app/img/v2/81c35d6bc1fbe47c83c63a1bd436f718.png";